import { createAction } from '@reduxjs/toolkit';
import { IScheduledValue } from '../../../../dto';
import { ACT_SET, MN_SCHEDULED_VALUES, TYPE_ELEMENT } from '../../../../common';

export const setScheduledValue = createAction<IScheduledValue>(
  `${MN_SCHEDULED_VALUES}/${TYPE_ELEMENT}/${ACT_SET}`,
);
